import React from 'react';
import { Link } from 'react-router-dom';
import { images } from '../data';

export default function Story({ copy }) {
  return (
    <section className="kido-story-section" id="story">
      <div className="kido-story-image">
        <img src={images.denimSet} alt="Children's denim set" />
        <span>პატარა მკვლევრები</span>
      </div>
      <div className="kido-story-copy">
        <p className="kido-eyebrow">02  /  {copy.story}</p>
        <h2>{copy.gift}</h2>
        <p>{copy.giftSub}</p>
        <Link className="kido-yellow-button" to="/shop">{copy.explore}<span>↗</span></Link>
      </div>
    </section>
  );
}
